import React from "react";

const MeetOut = () => {
  return <div>MeetOut</div>;
};

export default MeetOut;
